import { Box } from '@mui/material';
import React from 'react';
import Fan2FanItem from './Fan2FanItem';
import useEventContext from '@/contexts/event/useEventContext';
import useAnalyticsEvents from '@/hooks/useAnalyticsEvents';
import { useEffect } from 'react';

export default function Fan2FanTickets({ link }) {
  const { secondaryMarketTiketsAvailable } = useAnalyticsEvents();

  const {
    event: {
      event: { id, name },
    },
  } = useEventContext();

  useEffect(() => {
    secondaryMarketTiketsAvailable({ event_id: id, event_name: name });
  }, []);

  return (
    <>
      <Box
        sx={{
          fontWeight: 500,
          fontSize: '16px',
        }}
      >
        Otras opciones
      </Box>
      <Fan2FanItem link={link} data={{ event_id: id, event_name: name }} />
    </>
  );
}
